import Calendar from './calendar';

export default Calendar;



// WEBPACK FOOTER //
// ./js/components/calendar/index.jsx